export default __webpack_public_path__ + "static/media/iconBrandDisc.8bdfe4be.svg";